import NotifDispatchAccept from './notif-dispatch-accept'
import NotifDriverStatus from './notif-driver-status'
import NotifReservation from './notif-reservation'
import NotifOnOffDuty from './notif-onoffduty'

class Notifications {
  process (VueApp, payload) {
    console.log(payload)
    // read NID here...
    let data = payload.data

    if (data.AID === 'BOOKING_STATUS') {
      NotifReservation.process(VueApp, data)
      return
    }

    if (data.AID === 'DRIVER_STATUS') {
      NotifDriverStatus.process(VueApp, data)
      return
    }

    if (data.AID === 'DISPATCH_ACCEPT') {
      NotifDispatchAccept.process(VueApp, data)
      return
    }

    if (data.AID === 'ONOFF_DUTY') {
      NotifOnOffDuty.process(VueApp, data)
      return
    }
  }
}

export default new Notifications()



// WEBPACK FOOTER //
// ./src/modules/notifications/index.js